export default "__VITE_ASSET__xyMfNcQP__"